import React from 'react';
import PropTypes from 'prop-types';

import ImageMarkdown from './ImageMarkdown';
import ImageMarkdownCentered from './ImageMarkdownCentered';
import Instagram from './Instagram';
import LargeTeaser from './LargeTeaser';
import Markdown from './Markdown';
import ModuleWrapper from './ModuleWrapper';
import SingleImageBlock from './SingleImageBlock';
import TwoImageBlock from './TwoImageBlock';


const renderBlock = (block, index, slug) => {
  if (!block || !block.model || !block.model.apiKey) return null;

  switch (block.model.apiKey) {
    case 'single_image_medium':
      return <SingleImageBlock block={block} size="medium" />;
    case 'single_image':
      return <SingleImageBlock block={block} size="regular" />;
    case 'two_image':
      return <TwoImageBlock block={block} />;
    case 'markdown':
      return <Markdown block={block} />;
    case 'image_markdown':
      return <ImageMarkdown block={block} index={index} />;
    case 'image_markdown_centered':
      return <ImageMarkdownCentered block={block} index={index} slug={slug} />;
    case 'large_teaser':
      return <LargeTeaser block={block} />;
    case 'follow_on_instagram':
      return <Instagram block={block} />;
    default:
      return null;
  }
};

const BlockRouter = ({ block, index, slug }) => (
  <ModuleWrapper>
    {renderBlock(block, index, slug)}
  </ModuleWrapper>
);


BlockRouter.propTypes = {
  block: PropTypes.object.isRequired,
  index: PropTypes.number,
  slug: PropTypes.string,
};

BlockRouter.defaultProps = {
  index: 0,
};

export default BlockRouter;
